<template>
  <SimpleDataWithVariation
    :title="title"
    :item-id="itemId"
    :value="value"
    :variation="variation"
    :raw-variation="rawVariation"
    :request-status="requestStatus"
    :comparation-value="comparationValue"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import SimpleDataWithVariation from '@/components/cards/models/SimpleDataWithVariation';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { formatSocialNumberWithDecimal } from '@/utils/formatter';
import { calculateVariation } from '@/utils/math';
import blipModel from '@/mixins/blip-model';

export default {
  name: 'BaseBlipVariationChart',
  components: {
    SimpleDataWithVariation,
  },
  mixins: [
    blipModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    servicePath: {
      type: String,
      required: true,
    },
    interval: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      value: '',
      variation: '',
      rawVariation: '',
      comparationValue: '',
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getBlipServiceWithVariation',
      'hasNoBlipBotAndContractFiltered',
      'getAppliedCardFilter',
    ]),
    async getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      if (await this.hasNoBlipBotAndContractFiltered(this.itemId)) {
        this.requestStatus = 'emptyBot';
        return;
      }

      this.getBlipServiceWithVariation({
        servicePath: this.servicePath,
        interval: this.interval,
        itemId: this.itemId,
      })
        .then((response) => {
          try {
            const previousValue = this.processResponseStackCount(response.previousData);
            const currentValue = this.processResponseStackCount(response.currentData);

            const variation = calculateVariation(previousValue, currentValue);

            this.value = formatSocialNumberWithDecimal(currentValue);
            this.variation = variation;
            this.rawVariation = variation;
            this.comparationValue = formatSocialNumberWithDecimal(previousValue);

            this.requestStatus = 'success';

            if (options?.silentRefresh) {
              EventBus.$emit('updated', { itemId: this.itemId });
            }
          } catch (error) {
            console.error(`${JSON.stringify(error)}\nRequested in:`, this.servicePath);
            this.requestStatus = 'error';
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = error.message;
        });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
